import {
  Component,
  OnInit,
  AfterViewInit,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { Chart } from "chart.js";
import { opacity } from "html2canvas/dist/types/css/property-descriptors/opacity";
declare var google: any;
@Component({
  selector: "app-perio-chart",
  templateUrl: "./perio-chart.component.html",
  styleUrls: ["./perio-chart.component.scss"],
})
export class PerioChartComponent implements AfterViewInit {
  @ViewChild("tooth1") tooth1: ElementRef;
  @ViewChild("tooth2") tooth2: ElementRef;

  drawChart = () => {
    const data = google.visualization.arrayToDataTable([
      ["", ""],
      ["", 0],
      ["", 10],
      ["", 0],
    ]);
    const data2 = google.visualization.arrayToDataTable([
      ["", ""],
      ["", -0],
      ["", -0],
      ["", -3],
    ]);

    const options = {
      titlePosition: "none",
      legend: { position: "none", opacity: 0 },
      backgroundColor: "transparent",
      chartArea: {
        // left: 0,
        // top: 0,
        // width: "100%",
        // height: "100%",
        // backgroundColor: {
        //   stroke: 0,
        //   fill: "",
        // },
      },
      fill: {
        color: "",
      },
      vAxis: {
        textStyle: {
          opacity: 0,
        },
        gridlines: {
          color: "",
        },
        baseline: 0,
        minValue: 0,
      },
    };

    const options2 = {
      titlePosition: "none",
      legend: { position: "none", opacity: 0 },
      backgroundColor: "transparent",
      chartArea: {
        // left: 0,
        // top: 0,
        // width: "100%",
        // height: "100%",
        // backgroundColor: {
        //   stroke: 0,
        //   fill: "",
        // },
      },
      annotations: {
        boxStyle: { stroke: "red" },
      },
      fill: {
        color: "",
      },
      vAxis: {
        textStyle: {
          opacity: 0,
        },
        gridlines: {
          color: "",
        },
        baseline: 0,
        minValue: 0,
      },
      colors: ["red"],
    };

    // Positive data
    const chart = new google.visualization.AreaChart(this.tooth1.nativeElement);
    chart.draw(data, options);

    // Native data
    const chart2 = new google.visualization.AreaChart(
      this.tooth2.nativeElement
    );
    chart2.draw(data2, options2);
  };

  ngAfterViewInit() {
    google.charts.load("current", { packages: ["corechart"] });
    google.charts.setOnLoadCallback(this.drawChart);
  }

  // constructor() {}

  // dataArray: any = [];

  // ngAfterViewInit() {
  //   var data: any,
  //     data2: any,
  //     options: any,
  //     chart: any,
  //     ctx: any = document.getElementById("buccal") as HTMLElement;

  //   data = {
  //     labels: ["", "", ""],
  //     datasets: [
  //       {
  //         label: "",
  //         data: [
  //           0, -5, 2, 0, 10, 2, 0, 5, 0, 0, 2, 0, 0, 2, 0, 0, 0, 0, 2, 0, 0, 2,
  //           0, 0,
  //         ],
  //         borderWidth: 2,
  //         backgroundColor: "transparent",
  //         borderColor: "red",
  //         fill: false,
  //         lineTension: 0,
  //         radius: 0,
  //       },
  //     ],
  //   };

  //   options = {
  //     responsive: true,
  //     maintainAspectRatio: false,
  //     scales: {
  //       xAxes: [
  //         {
  //           gridLines: {
  //             display: false,
  //             color: "red",
  //           },
  //         },
  //       ],
  //       yAxes: [
  //         {
  //           gridLines: {
  //             display: false,
  //             color: "red",
  //           },
  //         },
  //       ],
  //     },
  //     title: {
  //       display: false,
  //     },
  //     legend: {
  //       display: false,
  //     },
  //   };

  //   chart = new Chart(ctx, {
  //     type: "line",
  //     data: data,
  //     options: options,
  //   });
  // }
}
